<div
  [hidden]="!data.show"
  attr.pdlPageComponentId="{{ pdlPageComponentId }}"
  attr.pdlRepeatedComponent="{{ pdlRepeatedComponent }}"
>
  <link
    rel="stylesheet"
    *ngFor="let css of data?.data?.cssUrls"
    [href]="sanitizer.bypassSecurityTrustResourceUrl(css)"
  />
  <div
    [hidden]="!data.show"
    [innerHTML]="sanitizer.bypassSecurityTrustHtml(data?.data?.html)"
  ></div>
</div>
